import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { ServiceProvider } from '../../../providers/ServiceProvider';
import { ODataDetailsPage } from '../ODataDetails/ODataDetails';
import { SettingProvider } from '../../../providers/SettingProvider';

/*
  Generated class for the CompanyDetails page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-CompanyDetails',
    templateUrl: 'CompanyDetails.html'
})
export class CompanyDetailsPage {
    Company: any;
    GetNotef: boolean = false;
    ODatas: any = [];
    CodataIdFOrTajhizat: any = null;
    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider,
        public toastController: ToastController, public settingProvider: SettingProvider) {
        this.LoadData();
    }
    LoadData() {
        this.Company = this.navParams.get("companyData");
        this.GetNotef = this.settingProvider.CompanyIsSelected(this.Company);
        this.ODatas.splice(0, this.ODatas.length);
        this.serviceProvider.Get("/VirtualForms/Customer/" + this.Company.Id, true).then((result) => {
            let odatas: any = result;
            console.log(result);
            odatas.forEach((value, item) => {
                this.ODatas.push(this.CreateOData(value));
            });
        });
    }
    CreateOData(item) {
        var value = {
            Id: item.Id,
            odTitle: item.odTitle,
            tCustomerODataId: item.tCustomerODataId,
            color: '',
            img: '',
            ShowInApp: item.showInApp
        };
        if (item.Id == 8) {
            this.CodataIdFOrTajhizat = item.tCustomerODataId;
        }
        switch (item.Id) {
            case 8:
                value.color = "#f95f5e";
                value.img = "ic_factory2.png";
                break;
            case 38:
                value.color = "#74b7df";
                value.img = "ic_doc.svg";
                break;
            case 37:
                value.color = "#a9a7a7";
                value.img = "ic_mine.svg";
                break;
            case 33:
                value.color = "#078702";
                value.img = "ic_gondole.png";
                break;
            case 34:
                value.color = "#faf097";
                value.img = "ic_fire.svg";
                break;
            case 35:
                value.color = "#F95F5E";
                value.img = "ic_cast.png";
                break;
            case 36:
                value.color = "#4297ca";
                value.img = "ic_roll.png";
                break;
            case 13:
                value.color = "#8fe77d";
                value.img = "ic_qc.png";
                break;
            case 17:
                value.color = "#fa7798";
                value.img = "ic_cert.png";
                break;
            case 18:
                value.color = "#ffffff";
                value.img = "ic_manager.png";
                break;
            case 19:
                value.color = "#eacf15";
                value.img = "ic_share.png";
                break;
            case 27:
                value.color = "#eacf15";
                value.img = "ic_power.png";
                break;
            case 28:
                value.color = "#74b7df";
                value.img = "ic_legal.svg";
                break;
            case 30:
                value.color = "#8fe77d";
                value.img = "ic_persons.svg";
                break;
            case 47:
                value.color = "#ffffff";
                value.img = "ic_light.svg";
                break;
        }
        return value;
    }

    ShowOdataDetails(odata) {
        if (odata.tCustomerODataId == null) {
            const toast = this.toastController.create({
                message: "اطلاعات این قسمت تکمیل نشده است",
                duration: 2000
            });
            toast.present();
            return;
        }
        if (odata.ShowInApp == false) {
            const toast = this.toastController.create({
                message: "اطلاعات این قسمت تکمیل نشده است",
                duration: 2000
            });
            toast.present();
            return;
        }
        this.navCtrl.push(ODataDetailsPage, { data: odata, TajhizatCoid: this.CodataIdFOrTajhizat });
    }

    GetNotifSetting() {
        if (!this.GetNotef) {
            this.settingProvider.RemoveCompany(this.Company);
        }
        else {
            this.settingProvider.AddCompany(this.Company);
        }
    }
    getCapacity(value) {
        if (value > 999999) {
            return (value / 1000000) + (value % 1000 > 0 ? "." + (value % 1000000):"") + " میلیون تن";
        }
        else if (value > 999) {
            return (value / 1000) + "" + (value % 1000 > 0 ? "." + (value % 1000):"") + " هزار تن";
        }
        else {
            return value + " تن";
        }
    }
    getCapacity1(value) {
        //if (value > 999999) {
        //    return (value / 1000000) + (value % 1000 > 0 ? "." + (value % 1000000) : "");
        //}
        //else
        if (value > 999) {
            return (value / 1000) + "" + (value % 1000 > 0 ? "." + (value % 1000) : "");
        }
        else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/atlas/CompanyDetails/CompanyDetails.ts